import classNames from 'classnames';
import LogoIcon from '../../icons/Logo.icon';
import Button from '../Button';
import './PageWrapper.styles.scss';

type PageWrapperProps = {
  children?: React.ReactNode;
  className?: string;
};

const PageWrapper: React.FC<PageWrapperProps> = (props) => {
  const { children, className } = props;

  const classes = classNames('data-room', className);

  return (
    <div className={classes}>
      <header>
        <div className="header-content">
          <LogoIcon />

          <Button
            onClick={() =>
              window.open(
                `resolve://auth?token=${localStorage.getItem('token')}`
              )
            }
          >
            Open Desktop Application
          </Button>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
};

export default PageWrapper;
